import http from '@/util/http'

class  DictApi {
// MOCK_PREFIX = '/mock/95';

  // 通过字典类型获取列表
  getDictListByTypeCode(params) {
    var url = '/share-foreign/dict/getDictListByTypeCode';
    return http.post(url, params);
  }

  // 通过字典类型获取列表
  getListByTypeCodeAndPCode(params) {
    var url = '/share-foreign/dict/getListByTypeCodeAndPCode';
    return http.post(url, params);
  }

  


}

export default DictApi
